import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getAllActiveRoomTypes } from "../roomtype/services/roomType.services";
import { getAllActiveMealTypes } from "../mealtype/services/mealtype.services";
import {
  getAllActiveSectors,
  getSectorByID,
} from "../sector/services/sector.services";
import { getAllActiveCompanies } from "../company/services/company.services";
import { getQuotationByID } from "../quotation/services/quotation.services";
import { clearFITBookingDetail, increaseActiveStep } from "./FITBookingSlice";
import ShadowCard from "../../components/common/ShadowCard";
import FormTextField from "../../components/formFields/FormTextField";
import {
  emailValidator,
  MobileNoIntValidator,
  MobileNoIntWOValueValidator,
  panWOValueValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { ISector } from "../sector/sectorModel";
import { ICompany } from "../company/companyModel";
import { NAMEPREFIX, SECTORTYPE } from "../../_contstants/common";
import FormDatePicker from "../../components/formFields/FormDateField";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import FormCheckbox from "../../components/formFields/FormCheckbox";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import RippleButton from "../../components/common/RippleButton";
import FITBookingAccomodationArray from "./FITBookingAccomodationArray";
import FITBookingTransportArray from "./FITBookingTransportArray";
import FITBookingMiscellaneousArray from "./FITBookingMiscellaneousArray";
import { getAllActiveVehicleTypes } from "../vehicletype/services/vehicletype.services";
import FormTextArea from "../../components/formFields/FormTextArea";
import { getAllActiveFoodOptions } from "../foodoption/services/foodOption.services";
import { IFoodOption } from "../foodoption/foodOptionModel";
import FormTimePicker from "../../components/formFields/FormTimeField";
import { insertContactFromOtherPlace } from "../contact/services/contact.services";
import {
  createFITBooking,
  getFITBookingByID,
  updateFITBooking,
} from "./services/FITBooking.services";
import { LoadingPanel } from "../../components/layout/Loading";
import { clearQuotationInformation } from "../quotation/quotationSlice";
import {
  getAllActiveHotelRoomCategory,
  getAllHotels,
} from "../hotel/services/hotel.services";
import { Button } from "@progress/kendo-react-buttons";
import { getAllActiveCurrencies } from "../currency/services/currency.services";
import { getAdminSettings } from "../adminsetting/services/adminsetting.services";
import { getSightseensBySectorID } from "../sightseen/services/sightseen.services";
import FITBookingSightseenArray from "./FITBookingSightseenArray";
import { Label } from "@progress/kendo-react-labels";
import { openDialog } from "../../components/dialog/dialogSlice";
import AppDialog from "../../components/dialog/Dialog";
import TravellerFITBookingRoomArray from "./TravellerFITBookingRoomArray";
import FormRichTextField from "../../components/formFields/FormRichTextField";

interface ChangeWatcherProps {
  formRenderProps: FormRenderProps;
}

const SectorChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const SectorList = useAppSelector((state) => state.sector.SectorList);
  const isCityRef = useRef(true);
  const SectorID = formRenderProps.valueGetter("SectorID");
  const location = useLocation();
  const dispatch = useAppDispatch();
  const FITBookingID = location.state?.FITBookingID;

  const handleTermsNCondition = async (SectorID: any) => {
    try {
      const isEmpty = formRenderProps.valueGetter("TermsNCondition");
      if (isEmpty === "" || isEmpty === "<br>") {
        const result: any = await dispatch(getSectorByID(SectorID));
        if (result?.meta?.requestStatus === "fulfilled") {
          formRenderProps.onChange("TermsNCondition", {
            value: result.payload.TermsNCondition,
          });
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  useEffect(() => {
    if (SectorID) {
      handleTermsNCondition(SectorID);
      dispatch(getSightseensBySectorID(SectorID));
      const currentSector = SectorList?.find((sector: ISector) => {
        return sector?.ID === +SectorID;
      });
      if (!isCityRef.current) {
        if (currentSector?.SectorType) {
          formRenderProps.onChange("Type", {
            value: currentSector?.SectorType,
          });
        }
      } else {
        if (!FITBookingID) {
          if (currentSector?.SectorType) {
            formRenderProps.onChange("Type", {
              value: currentSector?.SectorType,
            });
          }
        }
        isCityRef.current = false;
      }
    }
  }, [SectorID]);
  return null;
};

const TotalChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const AdminSettingDetails = useAppSelector(
    (state) => state.adminsetting.AdminSettingDetails,
  );

  const Transportations = formRenderProps.valueGetter("Transportations");
  const TransportaionConversionRate =
    formRenderProps.valueGetter("TransportaionConversionRate") || 1;
  const convertedTotalTransport =
    formRenderProps.valueGetter("convertedTotalTransport") || 0;

  const Miscellaneous = formRenderProps.valueGetter("Miscellaneous");
  const MiscellaneousConversionRate =
    formRenderProps.valueGetter("MiscellaneousConversionRate") || 1;
  const convertedTotalMiscellinious =
    formRenderProps.valueGetter("convertedTotalMiscellinious") || 0;

  const SightSeen = formRenderProps.valueGetter("SightSeen");
  const SightSeenConversionRate =
    formRenderProps.valueGetter("SightSeenConversionRate") || 1;
  const convertedTotalSightSeen =
    formRenderProps.valueGetter("convertedTotalSightSeen") || 0;

  const TotalAccomodation =
    formRenderProps.valueGetter("TotalAccomodation") || 0;
  const AccommodationConversionRate =
    formRenderProps.valueGetter("AccommodationConversionRate") || 1;
  const convertedTotalAccomodation =
    formRenderProps.valueGetter("convertedTotalAccomodation") || 0;

  const TotalTransport = formRenderProps.valueGetter("TotalTransport");
  const TotalMiscellinious =
    formRenderProps.valueGetter("TotalMiscellinious") || 0;
  const TotalSightSeen = formRenderProps.valueGetter("TotalSightSeen") || 0;
  const DriverAllowance = formRenderProps.valueGetter("DriverAllowance") || 0;
  const TotalTax = formRenderProps.valueGetter("TotalTax") || 0;
  const AccommodationMarkup =
    formRenderProps.valueGetter("AccommodationMarkup") || 0;
  const TransportMarkup = formRenderProps.valueGetter("TransportMarkup") || 0;
  const MiscellaneousMarkup =
    formRenderProps.valueGetter("MiscellaneousMarkup") || 0;
  const SightSeenMarkup = formRenderProps.valueGetter("SightSeenMarkup") || 0;

  const TotalMarkup = formRenderProps.valueGetter("TotalMarkup") || 0;
  const TotalAmount = formRenderProps.valueGetter("TotalAmount") || 0;
  const SubTotal = formRenderProps.valueGetter("SubTotal") || 0;
  const DiscountAmt = formRenderProps.valueGetter("DiscountAmt") || 0;
  const GSTAmt = formRenderProps.valueGetter("GSTAmt") || 0;
  const GSTPer = formRenderProps.valueGetter("GSTPer") || 0;
  const TCSAmt = formRenderProps.valueGetter("TCSAmt") || 0;
  const isTCS = formRenderProps.valueGetter("isTCS");
  const Type = formRenderProps.valueGetter("Type");
  const Accommodations = formRenderProps.valueGetter("Accommodations");

  let total_transport = 0;
  useEffect(() => {
    Transportations &&
      Transportations?.length > 0 &&
      Transportations?.map((item: any) => {
        total_transport += item?.Rate || 0;
      });

    formRenderProps.onChange("TotalTransport", {
      value: total_transport + +DriverAllowance + +TotalTax || 0,
    });
  }, [
    Transportations?.map((item: any) => item?.Rate)?.join(", "),
    DriverAllowance,
    TotalTax,
  ]);

  let total_miscellaneous = 0;
  useEffect(() => {
    Miscellaneous &&
      Miscellaneous?.length > 0 &&
      Miscellaneous?.map((item: any) => {
        total_miscellaneous += item?.TotalAmount || 0;
      });

    formRenderProps.onChange("TotalMiscellinious", {
      value: total_miscellaneous,
    });
  }, [Miscellaneous?.map((item: any) => item?.TotalAmount)?.join(", ")]);

  let total_sightseen = 0;
  useEffect(() => {
    SightSeen &&
      SightSeen?.length > 0 &&
      SightSeen?.map((item: any) => {
        total_sightseen += item?.Rate || 0;
      });

    formRenderProps.onChange("TotalSightSeen", {
      value: total_sightseen,
    });
  }, [SightSeen?.map((item: any) => item?.Rate)?.join(", ")]);

  useEffect(() => {
    formRenderProps.onChange("convertedTotalAccomodation", {
      value: AccommodationConversionRate * TotalAccomodation || 0,
    });
  }, [TotalAccomodation, AccommodationConversionRate]);

  useEffect(() => {
    formRenderProps.onChange("convertedTotalTransport", {
      value: TransportaionConversionRate * TotalTransport || 0,
    });
  }, [TotalTransport, TransportaionConversionRate]);

  useEffect(() => {
    formRenderProps.onChange("convertedTotalMiscellinious", {
      value: MiscellaneousConversionRate * TotalMiscellinious || 0,
    });
  }, [TotalMiscellinious, MiscellaneousConversionRate]);

  useEffect(() => {
    formRenderProps.onChange("convertedTotalSightSeen", {
      value: SightSeenConversionRate * TotalSightSeen || 0,
    });
  }, [TotalSightSeen, SightSeenConversionRate]);

  useEffect(() => {
    formRenderProps.onChange("TotalMarkup", {
      value:
        (AccommodationConversionRate * AccommodationMarkup || 0) +
          (TransportaionConversionRate * TransportMarkup || 0) +
          (MiscellaneousConversionRate * MiscellaneousMarkup || 0) +
          (SightSeenConversionRate * SightSeenMarkup || 0) || 0,
    });
  }, [
    AccommodationConversionRate,
    TransportaionConversionRate,
    MiscellaneousConversionRate,
    SightSeenConversionRate,
    AccommodationMarkup,
    TransportMarkup,
    MiscellaneousMarkup,
    SightSeenMarkup,
  ]);

  useEffect(() => {
    formRenderProps.onChange("TotalAmount", {
      value:
        +convertedTotalAccomodation +
          +convertedTotalTransport +
          +convertedTotalMiscellinious +
          +convertedTotalSightSeen +
          +TotalMarkup || 0,
    });
  }, [
    convertedTotalAccomodation,
    convertedTotalTransport,
    convertedTotalMiscellinious,
    convertedTotalSightSeen,
    +TotalMarkup,
  ]);

  useEffect(() => {
    formRenderProps.onChange("SubTotal", {
      value: +TotalAmount - +DiscountAmt || 0,
    });
  }, [DiscountAmt, TotalAmount]);

  useEffect(() => {
    formRenderProps.onChange("GSTAmt", {
      value: (+SubTotal * +GSTPer) / 100 || 0,
    });
  }, [SubTotal, GSTPer]);

  useEffect(() => {
    const totalAmount = +SubTotal + +GSTAmt;

    if (Type === "INTERNATIONAL") {
      if (isTCS) {
        if (totalAmount <= (AdminSettingDetails?.TCSLimit || 0)) {
          formRenderProps.onChange("TCSAmt", {
            value: (
              (+totalAmount * (AdminSettingDetails?.TCSUnderPer || 0)) /
              100
            )?.toFixed(2),
          });
        } else {
          const firstTCSAmount =
            ((AdminSettingDetails?.TCSLimit || 0) *
              (AdminSettingDetails?.TCSUnderPer || 0)) /
            100;
          const remainingTCSAmount =
            +totalAmount - (AdminSettingDetails?.TCSLimit || 0);
          const secondTCSAmount =
            (+remainingTCSAmount * (AdminSettingDetails?.TCSOverPer || 0)) /
            100;

          formRenderProps.onChange("TCSAmt", {
            value: +(+firstTCSAmount + +secondTCSAmount)?.toFixed(2),
          });
        }
      } else {
        formRenderProps.onChange("TCSAmt", {
          value: 0,
        });
      }
    } else {
      formRenderProps.onChange("TCSAmt", {
        value: 0,
      });
    }
  }, [SubTotal, GSTAmt, isTCS, Type]);

  useEffect(() => {
    formRenderProps.onChange("GrandTotal", {
      value: Math.round(+SubTotal + +GSTAmt + +TCSAmt || 0),
    });
  }, [SubTotal, GSTAmt, TCSAmt]);

  useEffect(() => {
    formRenderProps.onChange("RoundOff", {
      value:
        Math.round(+SubTotal + +GSTAmt + +TCSAmt || 0) -
        (SubTotal + +GSTAmt + +TCSAmt || 0),
    });
  }, [SubTotal, GSTAmt, TCSAmt]);

  useEffect(() => {
    const total = Accommodations.reduce((sum: number, accommodation: any) => {
      return sum + (Number(accommodation?.HotelAmount) || 0);
    }, 0);

    // Update the form field with the calculated total
    formRenderProps.onChange("TotalAccomodation", {
      value: total,
    });
  }, [Accommodations.map((e: any) => e?.HotelAmount)?.join("-")]);

  return null;
};

const HandlePanNoChange: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const PANCardNo = formRenderProps.valueGetter("PANCardNo");
  const handlePanNoChange = () => {
    formRenderProps.onChange("PANCardNo", { value: PANCardNo?.toUpperCase() });
  };
  useEffect(() => {
    handlePanNoChange();
  }, [PANCardNo]);

  return null;
};

const TourDateChange: React.FC<ChangeWatcherProps> = ({ formRenderProps }) => {
  const TourStartDate = formRenderProps.valueGetter("TourStartDate");
  const NoOfNights = formRenderProps.valueGetter("NoOfNights") || 0;

  useEffect(() => {
    formRenderProps.onChange("TourEndDate", {
      value: TourStartDate
        ? moment(TourStartDate).add(NoOfNights, "days").toDate()
        : null,
    });
  }, [TourStartDate, NoOfNights]);

  return null;
};

const AccomodationHotelChangeWatcher: React.FC<ChangeWatcherProps> = ({
  formRenderProps,
}) => {
  const dispatch = useAppDispatch();
  const Accommodations = formRenderProps.valueGetter("Accommodations");
  const isAccomodationHotelRef = useRef(true);

  const handleHotelChange = async (Hotel: number, index: number) => {
    const res = await dispatch(
      getAllActiveHotelRoomCategory({ HotelID: Hotel }),
    );
    if (res.meta?.requestStatus === "fulfilled") {
      formRenderProps.onChange(`Accommodations.${index}.roomtype_options`, {
        value: res.payload || [],
      });
    } else {
      formRenderProps.onChange(`Accommodations.${index}.roomtype_options`, {
        value: [],
      });
    }
  };

  useEffect(() => {
    if (Accommodations?.length > 0) {
      if (isAccomodationHotelRef.current) {
        Accommodations?.map((accomodation: any, index: number) => {
          const Hotel = accomodation.Hotel;
          if (Hotel) {
            handleHotelChange(+Hotel, index);
          }
        });
        isAccomodationHotelRef.current = false;
      }
    }
  }, [Accommodations]);

  return null;
};

const FITBookingStep1: React.FC = () => {
  const gridRef = useRef<any>(null);

  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const QuotationID = location.state?.QuotationID;
  const FITBookingID = location.state?.FITBookingID;

  const loading = useAppSelector((state) => state.FITBooking.loading);
  const contactLoading = useAppSelector((state) => state.contact.formLoading);

  const FITBookingDetail = useAppSelector(
    (state) => state.FITBooking.FITBookingDetail,
  );
  const QuotationDetail = useAppSelector(
    (state) => state.quotation.QuotationDetail,
  );

  const AdminSettingDetails = useAppSelector(
    (state) => state.adminsetting.AdminSettingDetails,
  );
  //   const LeadSourceList = useAppSelector(
  //     (state) => state.leadsource.LeadSourceList
  //   );
  const SectorList = useAppSelector((state) => state.sector.SectorList);
  const CompanyList = useAppSelector((state) => state.company.CompanyList);
  const FoodOptionList = useAppSelector(
    (state) => state.foodOption.FoodOptionList,
  );

  const [formKey, setFormKey] = useState(1);
  const [initialValues, setInitialValues] = useState<any>(FITBookingDetail);

  useEffect(() => {
    dispatch(getAllActiveRoomTypes());
    dispatch(getAllActiveMealTypes());
    dispatch(getAllActiveVehicleTypes());
    dispatch(getAllActiveFoodOptions());
    // dispatch(getAllActiveLeadSource());
    dispatch(getAllActiveSectors());
    dispatch(getAllActiveCompanies());
    dispatch(getAdminSettings());
    dispatch(getAllActiveCurrencies());

    if (!FITBookingID && QuotationID) {
      dispatch(getQuotationByID({ ID: +QuotationID }));
    }
    if (FITBookingID) {
      dispatch(getFITBookingByID({ ID: FITBookingID }));
    }
    return () => {
      dispatch(clearFITBookingDetail());
      dispatch(clearQuotationInformation());
    };
  }, []);

  useEffect(() => {
    if (QuotationDetail?.ID) {
      const startdate = QuotationDetail?.StartDate || "";
      const enddate = QuotationDetail?.EndDate || "";

      setInitialValues({
        // Name: `${QuotationDetail?.FirstName} ${QuotationDetail?.LastName}`,
        Initial: QuotationDetail?.Initial,
        FirstName: QuotationDetail?.FirstName,
        LastName: QuotationDetail?.LastName,
        MobileNo: QuotationDetail?.MobileNo,
        EmailID: QuotationDetail?.EmailID,
        CountryCode: QuotationDetail?.CountryCode,
        ContactID: QuotationDetail?.ContactID,
        QuotationID: QuotationDetail?.ID,
        FoodOptionID: QuotationDetail?.FoodPreferenceID,
        SectorID: QuotationDetail?.SectorID,
        CompanyID: QuotationDetail?.CompanyID,
        TourStartDate: QuotationDetail?.StartDate
          ? moment(QuotationDetail?.StartDate, "YYYY-MM-DD").toDate()
          : "",
        NoOfNights:
          startdate && enddate
            ? moment(enddate).diff(moment(startdate), "days")
            : null,
        TourEndDate: QuotationDetail?.EndDate
          ? moment(QuotationDetail?.EndDate, "YYYY-MM-DD").toDate()
          : "",
        TotalNoOfRooms: QuotationDetail?.TotalRoom,
        TotalAdults: QuotationDetail?.TotalAdult,
        TotalCWB: QuotationDetail?.TotalCWB,
        TotalCNB: QuotationDetail?.TotalCNB,
        ExtraAdult: QuotationDetail?.ExtraAdult,
        HotelRooms: QuotationDetail?.HotelRooms || [],
        Travelers: QuotationDetail?.Travelers,
        PickUpPlace: QuotationDetail?.PickUpPlace,
        PickUpDate: QuotationDetail?.PickUpDate
          ? moment(QuotationDetail?.PickUpDate, "YYYY-MM-DD").toDate()
          : "",
        DropPlace: QuotationDetail?.DropPlace,
        DropDate: QuotationDetail?.DropDate
          ? moment(QuotationDetail?.DropDate, "YYYY-MM-DD").toDate()
          : "",
        TotalAccomodation: QuotationDetail?.TotalAccommodationRate,
        DriverAllowance: QuotationDetail?.DriverAllowance,
        TotalTax: QuotationDetail?.TotalTax,
        TotalTransport: QuotationDetail?.Transportations,
        TotalMiscellinious: QuotationDetail?.Miscellaneous,
        DiscountAmt: QuotationDetail?.DiscountAmt,
        GSTPer: QuotationDetail?.GstPer,
        GSTAmt: QuotationDetail?.GstValue,
        isTCS: QuotationDetail?.isTCS,
        TCSAmt: QuotationDetail?.TCS,
        GrandTotal: QuotationDetail?.FinalAmt,
        Accommodations: QuotationDetail?.Accommodations,
        Transportations: QuotationDetail?.Transportations,
        Miscellaneous: QuotationDetail?.Miscellaneous,
        Type: QuotationDetail?.Type,
      });
    }
  }, [QuotationDetail]);

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      ...FITBookingDetail,
    });
  }, [FITBookingDetail]);

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      GstPer: AdminSettingDetails.GST,
    });
  }, [AdminSettingDetails]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [initialValues]);

  const handleHotelSearchChange = React.useCallback(
    async (search: string, field: string, formRenderProps: FormRenderProps) => {
      const result = await dispatch(getAllHotels({ HotelName: search }));
      if (result.payload) {
        formRenderProps.onChange(field, {
          value: result.payload,
        });
      }
    },
    [dispatch],
  );

  const handleSubmit = async (values: any) => {
    let contactID = values?.ContactID ? +values?.ContactID : null;
    const insertContactPayload = {
      Initial: values?.Initial ? values?.Initial : "",
      FirstName: values?.FirstName ? values?.FirstName : "",
      LastName: values?.LastName ? values?.LastName : "",
      MobileNo: values?.MobileNo ? values?.MobileNo : "",
      CountryCode: values?.CountryCode ? values?.CountryCode : "",
      EmailID: values?.EmailID ? values?.EmailID : "",
      LeadSourceID: values?.LeadSourceID ? +values?.LeadSourceID : null,
    };

    if (!QuotationID && !FITBookingID) {
      const response = await dispatch(
        insertContactFromOtherPlace(insertContactPayload),
      );

      if (
        response.meta.requestStatus === "fulfilled" &&
        response.payload?.Data?.ID
      ) {
        contactID = +response.payload.Data.ID || null;
      } else {
        return;
      }
    }

    try {
      if (FITBookingID) {
        const editPayload = {
          ID: FITBookingID ? +FITBookingID : null,
          ContactID: values?.ContactID ? +values?.ContactID : null,
          QuotationID: values?.QuotationID ? +values?.QuotationID : null,
          Initial: values?.Initial ? values?.Initial : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          CountryCode: values?.CountryCode ? values?.CountryCode : "",
          MobileNo: values?.MobileNo ? values?.MobileNo : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          Address: values?.Address ? values?.Address : "",
          CityName: values?.CityName ? values?.CityName : "",
          TravellingNo: values?.TravellingNo ? values?.TravellingNo : "",
          PANCardNo: values?.PANCardNo ? values?.PANCardNo : "",
          AadharNo: values?.AadharNo ? values?.AadharNo : "",
          FoodOptionID: values?.FoodOptionID ? values?.FoodOptionID : null,

          SectorID: values?.SectorID ? +values?.SectorID : null,
          CompanyID: values?.CompanyID ? +values?.CompanyID : null,
          Type: values?.Type ? values?.Type : "",
          TourStartDate: values?.TourStartDate
            ? moment(values?.TourStartDate)?.format("YYYY-MM-DD")
            : null,
          TourEndDate: values?.TourEndDate
            ? moment(values?.TourEndDate)?.format("YYYY-MM-DD")
            : null,
          NoOfNights: values?.NoOfNights ? +values?.NoOfNights : null,
          TotalNoOfRooms: values?.TotalNoOfRooms
            ? +values?.TotalNoOfRooms
            : null,
          TotalAdults: values?.TotalAdults ? +values?.TotalAdults : null,
          TotalCWB: values?.TotalCWB ? +values?.TotalCWB : null,
          TotalCNB: values?.TotalCNB ? +values?.TotalCNB : null,
          ExtraAdult: values?.ExtraAdult ? +values?.ExtraAdult : null,
          Travelers: values?.Travelers ? +values?.Travelers : null,
          HotelRooms: values?.HotelRooms ? values?.HotelRooms : [],

          PickUpPlace: values?.PickUpPlace ? values?.PickUpPlace : "",
          PickUpDate: values?.PickUpDate
            ? moment(values?.PickUpDate)?.format("YYYY-MM-DD")
            : null,
          PickUpTime: values?.PickUpTime
            ? moment(values?.PickUpTime)?.format("HH:mm:ss")
            : null,
          DropPlace: values?.DropPlace ? values?.DropPlace : "",
          DropDate: values?.DropDate
            ? moment(values?.DropDate)?.format("YYYY-MM-DD")
            : null,
          DropTime: values?.DropTime
            ? moment(values?.DropTime)?.format("HH:mm:ss")
            : null,

          TotalAccomodation: values?.TotalAccomodation
            ? +values?.TotalAccomodation
            : null,
          DriverAllowance: values?.DriverAllowance
            ? +values?.DriverAllowance
            : null,
          TotalTax: values?.TotalTax ? +values?.TotalTax : null,

          TotalTransport: values?.TotalTransport
            ? +values?.TotalTransport
            : null,
          TotalMiscellinious: values?.TotalMiscellinious
            ? +values?.TotalMiscellinious
            : null,
          TotalSightSeen: values?.TotalSightSeen
            ? +values?.TotalSightSeen
            : null,
          AccommodationMarkup: values?.AccommodationMarkup
            ? +values?.AccommodationMarkup
            : null,
          TransportMarkup: values?.TransportMarkup
            ? +values?.TransportMarkup
            : null,
          MiscellaneousMarkup: values?.MiscellaneousMarkup
            ? +values?.MiscellaneousMarkup
            : null,
          SightSeenMarkup: values?.SightSeenMarkup
            ? +values?.SightSeenMarkup
            : null,
          TotalMarkup: values?.TotalMarkup ? +values?.TotalMarkup : null,

          DiscountAmt: values?.DiscountAmt ? +values?.DiscountAmt : null,
          SubTotal: values?.SubTotal ? +values?.SubTotal : null,
          GSTPer: values?.GSTPer ? +values?.GSTPer : null,
          GSTAmt: values?.GSTAmt ? +(+values?.GSTAmt?.toFixed(2)) : null,
          isTCS: values?.isTCS ? values?.isTCS : false,
          IsGST: values?.IsGST ? values?.IsGST : false,
          IsDiscount: values?.IsDiscount ? values?.IsDiscount : false,
          TCSAmt: values?.TCSAmt ? +values?.TCSAmt : null,
          AccommodationConversionRate: values?.AccommodationConversionRate
            ? +values?.AccommodationConversionRate
            : null,
          TransportaionConversionRate: values?.TransportaionConversionRate
            ? +values?.TransportaionConversionRate
            : null,
          MiscellaneousConversionRate: values?.MiscellaneousConversionRate
            ? +values?.MiscellaneousConversionRate
            : null,
          SightSeenConversionRate: values?.SightSeenConversionRate
            ? +values?.SightSeenConversionRate
            : null,
          AccommodationCurrencyID: values?.AccommodationCurrencyID
            ? +values?.AccommodationCurrencyID
            : null,
          TransportaionCurrencyID: values?.TransportaionCurrencyID
            ? +values?.TransportaionCurrencyID
            : null,
          MiscellaneousCurrencyID: values?.MiscellaneousCurrencyID
            ? +values?.MiscellaneousCurrencyID
            : null,
          SightSeenCurrencyID: values?.SightSeenCurrencyID
            ? +values?.SightSeenCurrencyID
            : null,
          GrandTotal: values?.GrandTotal
            ? +(+values?.GrandTotal?.toFixed(2))
            : null,
          TermsNCondition: values?.TermsNCondition
            ? values?.TermsNCondition
            : "",

          Accommodations: values?.Accommodations
            ? values?.Accommodations?.map((item: any) => {
                return {
                  HotelCategoryID: item?.HotelCategoryID
                    ? item?.HotelCategoryID
                    : null,
                  PlaceID: item?.PlaceID ? item?.PlaceID : null,
                  Hotel: item?.Hotel ? `${item?.Hotel}` : "",
                  CheckInDate: item?.CheckInDate
                    ? moment(item?.CheckInDate)?.format("YYYY-MM-DD")
                    : null,
                  CheckOutDate: item?.CheckOutDate
                    ? moment(item?.CheckOutDate)?.format("YYYY-MM-DD")
                    : null,
                  RoomTypeID: !isNaN(Number(item?.Hotel))
                    ? item?.RoomTypeID
                      ? +item?.RoomTypeID
                      : null
                    : null,
                  RoomCategoryName: isNaN(Number(item?.Hotel))
                    ? item?.RoomCategoryName
                      ? item?.RoomCategoryName
                      : ""
                    : "",
                  MealTypeID: item?.MealTypeID ? +item?.MealTypeID : null,
                  TotalRoom: item?.TotalRoom ? +item?.TotalRoom : null,
                  HotelRate: item?.HotelRate ? +item?.HotelRate : null,
                  HotelAmount: item?.HotelAmount ? +item?.HotelAmount : null,
                };
              })
            : [],
          Transportations: values?.Transportations
            ? values?.Transportations?.map((item: any) => {
                return {
                  VehicleTypeID: item?.VehicleTypeID
                    ? +item?.VehicleTypeID
                    : null,
                  PlaceID: item?.PlaceID ? item?.PlaceID : null,
                  FromDate: item?.FromDate
                    ? moment(item?.FromDate)?.format("YYYY-MM-DD")
                    : null,
                  ToDate: item?.ToDate
                    ? moment(item?.ToDate)?.format("YYYY-MM-DD")
                    : null,
                  Rate: item?.Rate ? +item?.Rate : null,
                };
              })
            : [],
          Miscellaneous: values?.Miscellaneous
            ? values?.Miscellaneous?.map((item: any) => {
                return {
                  Title: item?.Title ? item?.Title : "",
                  TotalAmount: item?.TotalAmount ? +item?.TotalAmount : null,
                };
              })
            : [],
          SightSeen: values?.SightSeen
            ? values?.SightSeen?.map((item: any) => {
                return {
                  SightSeenID: item?.SightSeenID ? +item?.SightSeenID : null,
                  Rate: item?.Rate ? +item?.Rate : null,
                };
              })
            : [],
        };
        const response = await dispatch(updateFITBooking(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          // navigate("/fitbooking");
          dispatch(increaseActiveStep());
          dispatch(clearFITBookingDetail());
        }
      } else {
        const insertPayload = {
          ContactID: contactID,
          QuotationID: values?.QuotationID ? +values?.QuotationID : null,
          Initial: values?.Initial ? values?.Initial : "",
          FirstName: values?.FirstName ? values?.FirstName : "",
          LastName: values?.LastName ? values?.LastName : "",
          CountryCode: values?.CountryCode ? values?.CountryCode : "",
          MobileNo: values?.MobileNo ? values?.MobileNo : "",
          EmailID: values?.EmailID ? values?.EmailID : "",
          Address: values?.Address ? values?.Address : "",
          CityName: values?.CityName ? values?.CityName : "",
          TravellingNo: values?.TravellingNo ? values?.TravellingNo : "",
          PANCardNo: values?.PANCardNo ? values?.PANCardNo : "",
          AadharNo: values?.AadharNo ? values?.AadharNo : "",
          FoodOptionID: values?.FoodOptionID ? values?.FoodOptionID : null,

          SectorID: values?.SectorID ? +values?.SectorID : null,
          CompanyID: values?.CompanyID ? +values?.CompanyID : null,
          Type: values?.Type ? values?.Type : "",
          TourStartDate: values?.TourStartDate
            ? moment(values?.TourStartDate)?.format("YYYY-MM-DD")
            : null,
          TourEndDate: values?.TourEndDate
            ? moment(values?.TourEndDate)?.format("YYYY-MM-DD")
            : null,
          NoOfNights: values?.NoOfNights ? +values?.NoOfNights : null,
          TotalNoOfRooms: values?.TotalNoOfRooms
            ? +values?.TotalNoOfRooms
            : null,
          TotalAdults: values?.TotalAdults ? +values?.TotalAdults : null,
          TotalCWB: values?.TotalCWB ? +values?.TotalCWB : null,
          TotalCNB: values?.TotalCNB ? +values?.TotalCNB : null,
          ExtraAdult: values?.ExtraAdult ? +values?.ExtraAdult : null,
          Travelers: values?.Travelers ? +values?.Travelers : null,
          HotelRooms: values?.HotelRooms ? values?.HotelRooms : [],

          PickUpPlace: values?.PickUpPlace ? values?.PickUpPlace : "",
          PickUpDate: values?.PickUpDate
            ? moment(values?.PickUpDate)?.format("YYYY-MM-DD")
            : null,
          PickUpTime: values?.PickUpTime
            ? moment(values?.PickUpTime)?.format("HH:mm:ss")
            : null,
          DropPlace: values?.DropPlace ? values?.DropPlace : "",
          DropDate: values?.DropDate
            ? moment(values?.DropDate)?.format("YYYY-MM-DD")
            : null,
          DropTime: values?.DropTime
            ? moment(values?.DropTime)?.format("HH:mm:ss")
            : null,

          TotalAccomodation: values?.TotalAccomodation
            ? +values?.TotalAccomodation
            : null,
          DriverAllowance: values?.DriverAllowance
            ? +values?.DriverAllowance
            : null,
          TotalTax: values?.TotalTax ? +values?.TotalTax : null,

          TotalTransport: values?.TotalTransport
            ? +values?.TotalTransport
            : null,
          TotalMiscellinious: values?.TotalMiscellinious
            ? +values?.TotalMiscellinious
            : null,
          TotalSightSeen: values?.TotalSightSeen
            ? +values?.TotalSightSeen
            : null,
          AccommodationMarkup: values?.AccommodationMarkup
            ? +values?.AccommodationMarkup
            : null,
          TransportMarkup: values?.TransportMarkup
            ? +values?.TransportMarkup
            : null,
          MiscellaneousMarkup: values?.MiscellaneousMarkup
            ? +values?.MiscellaneousMarkup
            : null,
          SightSeenMarkup: values?.SightSeenMarkup
            ? +values?.SightSeenMarkup
            : null,
          TotalMarkup: values?.TotalMarkup ? +values?.TotalMarkup : null,

          DiscountAmt: values?.DiscountAmt ? +values?.DiscountAmt : null,
          SubTotal: values?.SubTotal ? +values?.SubTotal : null,
          GSTPer: values?.GSTPer ? +values?.GSTPer : null,
          GSTAmt: values?.GSTAmt ? +(+values?.GSTAmt?.toFixed(2)) : null,
          isTCS: values?.isTCS ? values?.isTCS : false,
          IsGST: values?.IsGST ? values?.IsGST : false,
          IsDiscount: values?.IsDiscount ? values?.IsDiscount : false,
          TCSAmt: values?.TCSAmt ? +values?.TCSAmt : null,
          AccommodationConversionRate: values?.AccommodationConversionRate
            ? +values?.AccommodationConversionRate
            : null,
          TransportaionConversionRate: values?.TransportaionConversionRate
            ? +values?.TransportaionConversionRate
            : null,
          MiscellaneousConversionRate: values?.MiscellaneousConversionRate
            ? +values?.MiscellaneousConversionRate
            : null,
          SightSeenConversionRate: values?.SightSeenConversionRate
            ? +values?.SightSeenConversionRate
            : null,
          AccommodationCurrencyID: values?.AccommodationCurrencyID
            ? +values?.AccommodationCurrencyID
            : null,
          TransportaionCurrencyID: values?.TransportaionCurrencyID
            ? +values?.TransportaionCurrencyID
            : null,
          MiscellaneousCurrencyID: values?.MiscellaneousCurrencyID
            ? +values?.MiscellaneousCurrencyID
            : null,
          SightSeenCurrencyID: values?.SightSeenCurrencyID
            ? +values?.SightSeenCurrencyID
            : null,
          GrandTotal: values?.GrandTotal
            ? +(+values?.GrandTotal?.toFixed(2))
            : null,
          TermsNCondition: values?.TermsNCondition
            ? values?.TermsNCondition
            : "",

          Accommodations: values?.Accommodations
            ? values?.Accommodations?.map((item: any) => {
                return {
                  PlaceID: item?.PlaceID ? item?.PlaceID : null,
                  HotelCategoryID: item?.HotelCategoryID
                    ? item?.HotelCategoryID
                    : null,
                  Hotel: item?.Hotel ? `${item?.Hotel}` : "",
                  CheckInDate: item?.CheckInDate
                    ? moment(item?.CheckInDate)?.format("YYYY-MM-DD")
                    : null,
                  CheckOutDate: item?.CheckOutDate
                    ? moment(item?.CheckOutDate)?.format("YYYY-MM-DD")
                    : null,
                  RoomTypeID: !isNaN(Number(item?.Hotel))
                    ? item?.RoomTypeID
                      ? +item?.RoomTypeID
                      : null
                    : null,
                  RoomCategoryName: isNaN(Number(item?.Hotel))
                    ? item?.RoomCategoryName
                      ? item?.RoomCategoryName
                      : ""
                    : "",
                  MealTypeID: item?.MealTypeID ? +item?.MealTypeID : null,
                  TotalRoom: item?.TotalRoom ? +item?.TotalRoom : null,
                  HotelRate: item?.HotelRate ? +item?.HotelRate : null,
                  HotelAmount: item?.HotelAmount ? +item?.HotelAmount : null,
                };
              })
            : [],
          Transportations: values?.Transportations
            ? values?.Transportations?.map((item: any) => {
                return {
                  VehicleTypeID: item?.VehicleTypeID
                    ? +item?.VehicleTypeID
                    : null,
                  PlaceID: item?.PlaceID ? item?.PlaceID : null,
                  FromDate: item?.FromDate
                    ? moment(item?.FromDate)?.format("YYYY-MM-DD")
                    : null,
                  ToDate: item?.ToDate
                    ? moment(item?.ToDate)?.format("YYYY-MM-DD")
                    : null,
                  Rate: item?.Rate ? +item?.Rate : null,
                };
              })
            : [],
          Miscellaneous: values?.Miscellaneous
            ? values?.Miscellaneous?.map((item: any) => {
                return {
                  Title: item?.Title ? item?.Title : "",
                  TotalAmount: item?.TotalAmount ? +item?.TotalAmount : null,
                };
              })
            : [],
          SightSeen: values?.SightSeen
            ? values?.SightSeen?.map((item: any) => {
                return {
                  SightSeenID: item?.SightSeenID ? +item?.SightSeenID : null,
                  Rate: item?.Rate ? +item?.Rate : null,
                };
              })
            : [],
        };
        const response = await dispatch(createFITBooking(insertPayload));
        if (
          response?.meta?.requestStatus === "fulfilled" &&
          response.payload.Data?.PackageBookingID
        ) {
          // navigate("/fitbooking");
          navigate("/fitbooking/edit", {
            state: {
              FITBookingID: response.payload.Data?.PackageBookingID,
              SectorID: values?.SectorID ? +values?.SectorID : null,
              mode: "create",
            },
          });
          dispatch(increaseActiveStep());
          // dispatch(clearFITBookingDetail());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {(loading || contactLoading) && <LoadingPanel gridRef={gridRef} />}
      <Form
        onSubmit={handleSubmit}
        key={formKey}
        initialValues={initialValues}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4 className="typography-head">
                    {FITBookingID ? "Update FIT Booking" : "Add FIT Booking"}
                  </Typography.h4>
                </GridLayoutItem>
                {/* {FITBookingID || QuotationID ? (
                <GridLayoutItem style={{ width: "100%" }} colSpan={3}>
                  <table className="w-100">
                    <tr>
                      <th>Name</th>
                      <td>:</td>
                      <td>
                        {initialValues?.Initial} {initialValues?.FirstName}{" "}
                        {initialValues?.LastName}
                      </td>
                    </tr>
                    <tr>
                      <th>Mobile No.</th>
                      <td>:</td>
                      <td>{initialValues?.MobileNo}</td>
                      <th>Email ID</th>
                      <td>:</td>
                      <td>{initialValues?.EmailID}</td>
                    </tr>
                  </table>
                  <hr className="mb-1" />
                </GridLayoutItem>
              ) : (
                <> */}
                <GridLayoutItem className="d-flex gap-2" colSpan={2}>
                  <Field
                    wrapperStyle={{
                      width: "100%",
                      flex: 1,
                    }}
                    id={"Initial"}
                    name={"Initial"}
                    label={"Initial"}
                    placeholder="i.e. Mr."
                    component={FormSelectionField}
                    options={NAMEPREFIX?.map((initial: any) => {
                      return {
                        value: initial?.value,
                        label: initial?.label,
                      };
                    })}
                  />
                  <Field
                    wrapperStyle={{
                      width: "100%",
                      flex: 2,
                    }}
                    name="FirstName"
                    label="First Name"
                    placeholder="i.e.John"
                    maxLength="30"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                  {/* </GridLayoutItem>
              <GridLayoutItem> */}
                  <Field
                    wrapperStyle={{
                      width: "100%",
                      flex: 2,
                    }}
                    name="LastName"
                    label="Last Name"
                    placeholder="i.e. Smith"
                    maxLength="30"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="EmailID"
                    label="Email ID"
                    astrike={true}
                    placeholder="i.e. example@gmail.com"
                    component={FormTextField}
                    validator={emailValidator}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem className="mb-1">
                  <Field
                    wrapperStyle={{
                      width: "100%",
                      flex: 1,
                    }}
                    name="CountryCode"
                    label="Code"
                    astrike={true}
                    placeholder="i.e. In"
                    component={CountryCodeField}
                    validator={requiredValidator}
                  />
                </GridLayoutItem> */}
                <GridLayoutItem>
                  <Field
                    // wrapperStyle={{
                    //   width: "100%",
                    //   flex: 2,
                    // }}
                    name="MobileNo"
                    label="Mobile No."
                    // type="number"
                    // max={16}
                    type="text"
                    maxLength={16}
                    onKeyPress={(e: any) => {
                      const allowedChars = /^[0-9+]$/;
                      if (!allowedChars.test(e?.key)) {
                        e.preventDefault();
                      }
                    }}
                    placeholder="i.e. 9999999999"
                    component={FormTextField}
                    astrike={true}
                    validator={MobileNoIntValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperStyle={{
                      width: "100%",
                      flex: 2,
                    }}
                    name="TravellingNo"
                    label="Travelling No."
                    type="number"
                    max={16}
                    placeholder="i.e. 9999999999"
                    component={FormTextField}
                    validator={MobileNoIntWOValueValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2}>
                  <Field
                    name="Address"
                    label="Address"
                    placeholder="Address"
                    rows={1}
                    component={FormTextArea}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="CityName"
                    label="City"
                    placeholder="i.e. Ahmedabad"
                    maxLength="30"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="PANCardNo"
                    label="PAN No."
                    placeholder="PAN No."
                    maxLength={10}
                    validator={panWOValueValidator}
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="AadharNo"
                    label="Aadhar No"
                    placeholder="Aadhar No"
                    type="number"
                    component={FormTextField}
                    max={12}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="w-100"
                    id={"FoodOptionID"}
                    name={"FoodOptionID"}
                    label={"Food Preference"}
                    placeholder="Food Preference"
                    component={FormSelectionField}
                    isAddNew={true}
                    isIndirect={true}
                    drawerName="foodoptionForm"
                    options={FoodOptionList?.map((foodoption: IFoodOption) => {
                      return {
                        value: foodoption?.ID,
                        label: foodoption?.Name,
                      };
                    })}
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem colSpan={3}>
                <hr className="mb-1" />
              </GridLayoutItem> */}
                {/* </>
              )} */}
                <GridLayoutItem colSpan={3} className="pt-4">
                  <Typography.h5 className="typography-head mb-0">
                    Tour Details
                  </Typography.h5>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="w-100"
                    id={"SectorID"}
                    name={"SectorID"}
                    label={"Sector"}
                    placeholder="Sector"
                    component={FormSelectionField}
                    astrike={true}
                    validator={requiredValidator}
                    options={SectorList?.map((sector: ISector) => {
                      return {
                        value: sector?.ID,
                        label: sector?.SectorName,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="w-100"
                    id={"CompanyID"}
                    name={"CompanyID"}
                    label={"Company"}
                    placeholder="Company"
                    component={FormSelectionField}
                    astrike={true}
                    validator={requiredValidator}
                    options={CompanyList?.map((company: ICompany) => {
                      return {
                        value: company?.ID,
                        label: company?.CompanyName,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="w-100"
                    id={"Type"}
                    name={"Type"}
                    label={"Type"}
                    placeholder="Type"
                    component={FormSelectionField}
                    astrike={true}
                    validator={requiredValidator}
                    options={SECTORTYPE?.map((type: any) => {
                      return {
                        value: type?.value,
                        label: type?.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="TourStartDate"
                    label="Tour Start Date"
                    format="dd/MM/yyyy"
                    component={FormDatePicker}
                    astrike={true}
                    validator={requiredValidator}
                    minDate={moment().toDate()}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="NoOfNights"
                    label="No Of Nights"
                    placeholder="0"
                    max={50}
                    format="n0"
                    component={FormNumericTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="TourEndDate"
                    label="Tour End Date"
                    format="dd/MM/yyyy"
                    disabled={true}
                    astrike={true}
                    validator={requiredValidator}
                    minDate={moment(
                      formRenderProps.valueGetter("TourStartDate"),
                    ).toDate()}
                    component={FormDatePicker}
                  />
                </GridLayoutItem>
                <GridLayoutItem className="d-flex gap-2">
                  <div
                    style={{
                      marginTop: 15,
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <Label>
                      {"Travellers"}
                      <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Button
                      type="button"
                      style={{ background: "#fff" }}
                      onClick={() =>
                        dispatch(openDialog("fitBookingtravellerEditDialog"))
                      }
                    >
                      {formRenderProps.valueGetter("Travelers") || 0}
                    </Button>
                  </div>
                  <TravellerEditDialog formRenderProps={formRenderProps} />
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="TotalNoOfRooms"
                    label="Total Room"
                    placeholder="0"
                    min={0}
                    max={50}
                    format="n0"
                    component={FormNumericTextField}
                    validator={requiredValidator}
                    astrike={true}
                    disabled
                  />
                </GridLayoutItem>
                <GridLayoutItem className="d-flex gap-2">
                  {/* </GridLayoutItem>
              <GridLayoutItem> */}
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="TotalAdults"
                    label="Total Adult"
                    placeholder="0"
                    min={0}
                    max={50}
                    format="n0"
                    component={FormNumericTextField}
                    validator={requiredValidator}
                    astrike={true}
                    disabled
                  />
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="ExtraAdult"
                    label="Extra Adult"
                    placeholder="0"
                    min={0}
                    max={50}
                    format="n0"
                    component={FormNumericTextField}
                    disabled
                  />
                </GridLayoutItem>

                <GridLayoutItem className="d-flex gap-2">
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="TotalCWB"
                    label="Total CWB"
                    placeholder="0"
                    min={0}
                    max={50}
                    format="n0"
                    component={FormNumericTextField}
                    disabled
                  />
                  {/* </GridLayoutItem>
              <GridLayoutItem> */}
                  <Field
                    wrapperClassName="right-aligned-field w-100"
                    name="TotalCNB"
                    label="Total CNB"
                    placeholder="0"
                    min={0}
                    max={50}
                    format="n0"
                    component={FormNumericTextField}
                    disabled
                  />
                </GridLayoutItem>
                {/* <GridLayoutItem colSpan={3}>
                <hr className="mb-1" />
              </GridLayoutItem> */}
                {/* </>
              )} */}
                <GridLayoutItem colSpan={3} className="pt-4">
                  <Typography.h5 className="typography-head mb-0">
                    Pickup Details
                  </Typography.h5>
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name="PickUpPlace"
                    label="PickUp Place"
                    placeholder="PickUp Place"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="PickUpDate"
                    label="Pickup Date"
                    format="dd/MM/yyyy"
                    component={FormDatePicker}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    id={"PickUpTime"}
                    name={"PickUpTime"}
                    label={"PickUp Time"}
                    component={FormTimePicker}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name="DropPlace"
                    label="Drop Place"
                    placeholder="Drop Place"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="DropDate"
                    label="Drop Date"
                    format="dd/MM/yyyy"
                    minDate={moment(
                      formRenderProps.valueGetter("PickUpDate"),
                    ).toDate()}
                    component={FormDatePicker}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    id={"DropTime"}
                    name={"DropTime"}
                    label={"Drop Time"}
                    component={FormTimePicker}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            {(formRenderProps?.valueGetter("Accommodations")?.length < 1 ||
              formRenderProps?.valueGetter("Transportations")?.length < 1 ||
              formRenderProps?.valueGetter("Miscellaneous")?.length < 1 ||
              formRenderProps?.valueGetter("SightSeen")?.length < 1) && (
              <ShadowCard
                style={{
                  padding: 10,
                  marginTop: 10,
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                {formRenderProps?.valueGetter("Accommodations")?.length < 1 && (
                  <Button
                    fillMode={"solid"}
                    themeColor={"primary"}
                    type="button"
                    onClick={() => {
                      formRenderProps.onChange("Accommodations", {
                        value: [
                          {
                            PlaceID: null,
                            HotelCategoryID: "",
                            Hotel: "",
                            CheckInDate: "",
                            CheckOutDate: "",
                            RoomTypeID: null,
                            MealTypeID: null,
                            TotalRoom: null,
                          },
                        ],
                      });
                    }}
                  >
                    Add Accommodation
                  </Button>
                )}
                {formRenderProps?.valueGetter("Transportations")?.length <
                  1 && (
                  <Button
                    fillMode={"solid"}
                    themeColor={"primary"}
                    type="button"
                    onClick={() => {
                      formRenderProps.onChange("Transportations", {
                        value: [
                          {
                            VehicleTypeID: null,
                            PlaceID: null,
                            FromDate: "",
                            ToDate: "",
                            Rate: null,
                          },
                        ],
                      });
                    }}
                  >
                    Add Transport
                  </Button>
                )}
                {formRenderProps?.valueGetter("Miscellaneous")?.length < 1 && (
                  <Button
                    fillMode={"solid"}
                    themeColor={"primary"}
                    type="button"
                    onClick={() => {
                      formRenderProps.onChange("Miscellaneous", {
                        value: [
                          {
                            Title: "",
                            TotalAmount: null,
                          },
                        ],
                      });
                    }}
                  >
                    Add Miscellaneous
                  </Button>
                )}
                {formRenderProps?.valueGetter("SightSeen")?.length < 1 && (
                  <Button
                    fillMode={"solid"}
                    themeColor={"primary"}
                    type="button"
                    onClick={() => {
                      formRenderProps.onChange("SightSeen", {
                        value: [
                          {
                            SightSeenID: null,
                            Rate: null,
                          },
                        ],
                      });
                    }}
                  >
                    Add SightSeen
                  </Button>
                )}
              </ShadowCard>
            )}
            {formRenderProps?.valueGetter("Accommodations")?.length > 0 && (
              <ShadowCard style={{ padding: 10, marginTop: 10 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4 className="typography-head m-0">
                      {"Accommodation Details"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <FieldArray
                      formRenderProps={formRenderProps}
                      component={FITBookingAccomodationArray}
                      name="Accommodations"
                      handleHotelSearchChange={handleHotelSearchChange}
                    />
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
            )}
            {formRenderProps?.valueGetter("Transportations")?.length > 0 && (
              <ShadowCard style={{ padding: 10, marginTop: 10 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4 className="typography-head m-0">
                      {"Transport Details"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <FieldArray
                      formRenderProps={formRenderProps}
                      component={FITBookingTransportArray}
                      name="Transportations"
                    />
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={2}></GridLayoutItem>
                  {formRenderProps.valueGetter("Transportations")?.length >
                    0 && (
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="calculation-label right-aligned-field"
                        wrapperStyle={{ margin: 0, width: "100%" }}
                        label={"Total"}
                        name="TotalTransport"
                        format="n2"
                        placeholder="0"
                        component={FormNumericTextField}
                        disabled="true"
                      />
                    </GridLayoutItem>
                  )}
                </GridLayout>
              </ShadowCard>
            )}
            {formRenderProps?.valueGetter("Miscellaneous")?.length > 0 && (
              <ShadowCard style={{ padding: 10, marginTop: 10 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4 className="typography-head m-0">
                      {"Miscellaneous Details"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <FieldArray
                      formRenderProps={formRenderProps}
                      component={FITBookingMiscellaneousArray}
                      name="Miscellaneous"
                    />
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
            )}

            {formRenderProps?.valueGetter("SightSeen")?.length > 0 && (
              <ShadowCard style={{ padding: 10, marginTop: 10 }}>
                <GridLayout
                  style={{ marginRight: 20 }}
                  gap={{ rows: 0, cols: 10 }}
                  cols={[
                    { width: "33.33%" },
                    { width: "33.33%" },
                    { width: "33.33%" },
                  ]}
                >
                  <GridLayoutItem colSpan={3}>
                    <Typography.h4 className="typography-head m-0">
                      {"SightSeen Details"}
                    </Typography.h4>
                  </GridLayoutItem>
                  <GridLayoutItem colSpan={3}>
                    <FieldArray
                      formRenderProps={formRenderProps}
                      component={FITBookingSightseenArray}
                      name="SightSeen"
                    />
                  </GridLayoutItem>
                </GridLayout>
              </ShadowCard>
            )}

            <ShadowCard style={{ padding: 10, marginTop: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4 className="typography-head m-0">
                    {"Terms & Conditions"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3}>
                  <GridLayoutItem>
                    <Field
                      name="TermsNCondition"
                      component={FormRichTextField}
                      contentHeight={250}
                    />
                  </GridLayoutItem>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ padding: 10, marginTop: 10 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <div
                    style={{
                      width: "100%",
                      marginTop: "0px",
                    }}
                  >
                    <table style={{ width: "100%" }}>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            paddingBottom: 5,
                          }}
                        >
                          Total Accommodation <code>(A)</code>
                        </td>
                        <td
                          style={{
                            width: "5%",
                            textAlign: "center",
                            paddingBottom: 5,
                          }}
                        >
                          :
                        </td>
                        <td style={{ width: 200, paddingBottom: 5 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="convertedTotalAccomodation"
                            format="n2"
                            placeholder="0"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            paddingBottom: 5,
                          }}
                        >
                          Total Transport <code>(B)</code>
                        </td>
                        <td
                          style={{
                            width: "5%",
                            textAlign: "center",
                            paddingBottom: 5,
                          }}
                        >
                          :
                        </td>
                        <td style={{ width: 200, paddingBottom: 5 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="convertedTotalTransport"
                            format="n2"
                            placeholder="0"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            paddingBottom: 5,
                          }}
                        >
                          Total Miscellaneous <code>(C)</code>
                        </td>
                        <td
                          style={{
                            width: "5%",
                            textAlign: "center",
                            paddingBottom: 5,
                          }}
                        >
                          :
                        </td>
                        <td style={{ width: 200, paddingBottom: 5 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="convertedTotalMiscellinious"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            paddingBottom: 5,
                          }}
                        >
                          Total SightSeen <code>(D)</code>
                        </td>
                        <td
                          style={{
                            width: "5%",
                            textAlign: "center",
                            paddingBottom: 5,
                          }}
                        >
                          :
                        </td>
                        <td style={{ width: 200, paddingBottom: 5 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="convertedTotalSightSeen"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            paddingBottom: 5,
                          }}
                        >
                          Total Markup <code>(E)</code>
                        </td>
                        <td
                          style={{
                            width: "5%",
                            textAlign: "center",
                            paddingBottom: 5,
                          }}
                        >
                          :
                        </td>
                        <td style={{ width: 200, paddingBottom: 5 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="TotalMarkup"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderTop: "1px solid gainsboro",
                        }}
                      >
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "5px 0",
                          }}
                        >
                          Total <code>(F) = (A + B + C + D + E)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}></td>
                        <td style={{ width: 200, padding: "5px 0 0" }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="TotalAmount"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderBottom: "1px solid gainsboro",
                        }}
                      >
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "10px 0",
                          }}
                        >
                          <Field
                            name="IsDiscount"
                            label="is Discount Apply"
                            component={FormCheckbox}
                            wrapperStyle={{
                              fontWeight: 600,
                              margin: 0,
                              display: "inline-block",
                            }}
                            style={{ border: "1px solid darkgray" }}
                            onChange={() => {
                              formRenderProps.onChange("DiscountAmt", {
                                value: 0,
                              });
                            }}
                          />{" "}
                          <code>(G)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="DiscountAmt"
                            placeholder="0"
                            min={0}
                            format="n2"
                            max={formRenderProps.valueGetter("TotalAmount")}
                            component={FormNumericTextField}
                          />
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderTop: "1px solid gainsboro",
                        }}
                      >
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "10px 0",
                          }}
                        >
                          Total <code>(H) = (F - G)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="SubTotal"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderTop: "1px solid gainsboro",
                        }}
                      >
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "5px 0",
                          }}
                        >
                          <div className="d-flex gap-1 align-items-center justify-content-end">
                            <Field
                              name="IsGST"
                              label="is GST Apply"
                              component={FormCheckbox}
                              wrapperStyle={{
                                fontWeight: 600,
                                margin: 0,
                                display: "inline-block",
                              }}
                              style={{ border: "1px solid darkgray" }}
                              onChange={() => {
                                formRenderProps.onChange("GSTPer", {
                                  value: 0,
                                });
                              }}
                            />{" "}
                            <code>(I)</code>{" "}
                            {formRenderProps.valueGetter("IsGST") && (
                              <>
                                <Field
                                  wrapperClassName="calculation-label right-aligned-field"
                                  wrapperStyle={{ margin: 0, maxWidth: 100 }}
                                  name="GSTPer"
                                  placeholder="0"
                                  format="n2"
                                  min={0}
                                  max={100}
                                  component={FormNumericTextField}
                                />
                                (%)
                              </>
                            )}
                          </div>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="GSTAmt"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "5px 0",
                          }}
                        >
                          <Field
                            name="isTCS"
                            label="is TCS Apply"
                            component={FormCheckbox}
                            wrapperStyle={{
                              fontWeight: 600,
                              margin: 0,
                              display: "inline-block",
                            }}
                            style={{ border: "1px solid darkgray" }}
                          />{" "}
                          <code>(J)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200, padding: "0 0 5px" }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="TCSAmt"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "5px 0",
                          }}
                        >
                          Round Off <code>(K)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200, padding: "0 0 5px" }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="RoundOff"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                      <tr
                        style={{
                          borderTop: "1px solid gainsboro",
                          borderBottom: "1px solid gainsboro",
                        }}
                      >
                        <td
                          style={{
                            width: "calc(100% - 210px)",
                            textAlign: "end",
                            fontWeight: 600,
                            padding: "10px 0",
                          }}
                        >
                          Grand Total <code>(L) = (H + I + J)</code>
                        </td>
                        <td style={{ width: "5%", textAlign: "center" }}>:</td>
                        <td style={{ width: 200 }}>
                          <Field
                            wrapperClassName="calculation-label right-aligned-field"
                            wrapperStyle={{ margin: 0, width: "100%" }}
                            name="GrandTotal"
                            placeholder="0"
                            format="n2"
                            component={FormNumericTextField}
                            disabled="true"
                          />
                        </td>
                      </tr>
                    </table>
                  </div>
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    textAlign: "end",
                    marginTop: 20,
                    width: "100%",
                  }}
                >
                  <ButtonWithLoading
                    label={FITBookingID ? "Update" : "Save"}
                    type="submit"
                    disabled={
                      !formRenderProps.allowSubmit || loading || contactLoading
                    }
                    loading={loading || contactLoading}
                  />
                  <RippleButton
                    fillMode="outline"
                    themeColor="primary"
                    style={{ marginLeft: 10 }}
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </RippleButton>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <SectorChangeWatcher formRenderProps={formRenderProps} />
            <TotalChangeWatcher formRenderProps={formRenderProps} />
            <HandlePanNoChange formRenderProps={formRenderProps} />
            <TourDateChange formRenderProps={formRenderProps} />
            <AccomodationHotelChangeWatcher formRenderProps={formRenderProps} />
          </FormElement>
        )}
      />
    </>
  );
};

interface TravellerEditDialogProps {
  formRenderProps: FormRenderProps;
}

const TravellerEditDialog: React.FC<TravellerEditDialogProps> = ({
  formRenderProps,
}) => {
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  return (
    <>
      {dialogName === "fitBookingtravellerEditDialog" && (
        <AppDialog>
          <GridLayout style={{ maxWidth: 600 }}>
            <FieldArray
              formRenderProps={formRenderProps}
              component={TravellerFITBookingRoomArray}
              name="HotelRooms"
            />
          </GridLayout>
        </AppDialog>
      )}
    </>
  );
};

export default FITBookingStep1;
